import {
  Box,
  CardHeader as MuiCardHeader,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Button as MuiButton,
  styled,
} from "@mui/material";

export const CardWrapper = styled(Box)(({ theme }) => ({
  height: "100%",
  border: `0.0625rem solid
    ${
      theme.palette.mode === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[700]
    }`,
  padding: "0.5rem",
  borderRadius: "2rem",
  background:
    theme.palette.mode === "light"
      ? "linear-gradient(135deg, rgba(255,255,255,0.3), rgba(180,180,180,0.2))"
      : "linear-gradient(135deg, rgba(60,60,60,0.3), rgba(40,40,40,0.3))",
  backdropFilter: "blur(0.5rem)",
  WebkitBackdropFilter: "blur(0.5rem)",
  boxShadow: "0 0.25rem 1.25rem rgba(0,0,0,0.05)",
}));

export const Card = styled(MuiCard)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 1.5rem;
  padding: 1.5rem;
`;

export const CardHeader = styled(MuiCardHeader)`
  padding: 0;
  text-align: left;
`;

export const HeaderBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContentBox = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  margin: 1.5rem 0;
`;

export const CardContent = styled(MuiCardContent)`
  padding: 0;
`;

export const Button = styled(MuiButton)`
  border-radius: 0.625rem;
`;

export const List = styled("ul")(({ theme }) => ({
  padding: "1rem",

  "& li": {
    paddingLeft: "0.5rem",
    lineHeight: 2,
  },
  "& li::marker": {
    content: '" + "',
    color: theme.palette.grey[400],
    fontWeight: "bold",
  },
}));
